var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about"},[_c('h1',[_vm._v("This is an about page")]),_c('div',{staticClass:"button-container"},[_c('md-button',{staticClass:"md-raised md-icon-button go-btn"},[_c('md-icon',[_vm._v("play_arrow")])],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }